import { useState, useLayoutEffect, useRef, ReactNode, RefObject } from 'react';

type UseChildHeightResult = [RefObject<HTMLDivElement | null>, number];

const useChildHeight = (children: ReactNode): UseChildHeightResult => {
  const [childrenHeight, setChildrenHeight] = useState(0);
  const childrenWrapperRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (!childrenWrapperRef.current) return;

    const calculateHeight = () => {
      if (childrenWrapperRef.current) {
        setChildrenHeight(childrenWrapperRef.current.offsetHeight);
      }
    };

    calculateHeight();

    const observer = new MutationObserver(calculateHeight);

    observer.observe(childrenWrapperRef.current, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true,
    });

    return () => observer.disconnect();
  }, [children]);

  return [childrenWrapperRef, childrenHeight];
};

export default useChildHeight;
